<template>

    <div id="catalog-filter">
        <div class="catalog-filter-card">
            <div class="mb-24 d-flex align-items-center justify-content-between">
                <div class="title-4 mb-0">Фильтр</div>
                <div @click="closeFilter()" class="d-block d-xl-none"><img src="/svg/close.svg" alt=""></div>
            </div>

            <div class="h5 mb-16" v-if="brands">Бренд</div>

            <div class="mb-16">
                <input type="text" v-model="brand_search" class="input-box" placeholder="Название бренда">
            </div>

            <div v-if="brands" class="mb-40">
                <div class="brands-container">
                    <div class="mb-12 checkbox" v-for="(item, i) in filtered_brands" :key="i">
                        <input :id="item.code" type="checkbox" :value="item" v-model="filter_brands">
                        <label :for="item.code">{{item.name}}</label>
                    </div>
                </div>
            </div>

            <div v-if="cameraTypes && show_camera_type == true">
                <div class="h5 mb-16" >Типы камер</div>
                <div class="mb-40">
                    <div class="brands-container">
                        <div class="mb-12 checkbox" v-for="(item, i) in cameraTypes" :key="i">
                            <input :id="'camera_type' + item.id" type="checkbox" :value="item" v-model="filter_camera_types">
                            <label :for="'camera_type' + item.id">{{item.name}}</label>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="matrixSizes && show_matrix_size == true">
                <div class="h5 mb-16" >Размер матрицы</div>
                <div class="mb-40">
                    <div class="brands-container">
                        <div class="mb-12 checkbox" v-for="(item, i) in matrixSizes" :key="i">
                            <input :id="'matrix_size' + item.id" type="checkbox" :value="item" v-model="filter_matrix_sizes">
                            <label :for="'matrix_size' + item.id">{{item.name}}</label>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="lensTypes && show_lens_type == true">
                <div class="h5 mb-16" >Тип объектива</div>
                <div class="mb-40">
                    <div class="brands-container">
                        <div class="mb-12 checkbox" v-for="(item, i) in lensTypes" :key="i">
                            <input :id="'lens_type' + item.id" type="checkbox" :value="item" v-model="filter_lens_types">
                            <label :for="'lens_type' + item.id">{{item.name}}</label>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="bayonets && show_bayonet == true">
                <div class="h5 mb-16" >Байонет</div>
                <div class="mb-40">
                    <div class="brands-container">
                        <div class="mb-12 checkbox" v-for="(item, i) in bayonets" :key="i">
                            <input :id="'bayonet' + item.id" type="checkbox" :value="item" v-model="filter_bayonets">
                            <label :for="'bayonet' + item.id">{{item.name}}</label>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="maximumApertures && show_maximum_aperture == true">
                <div class="h5 mb-16" >Максимальная диафрагма</div>
                <div class="mb-40">
                    <div class="brands-container">
                        <div class="mb-12 checkbox" v-for="(item, i) in maximumApertures" :key="i">
                            <input :id="'maximum_aperture' + item.id" type="checkbox" :value="item" v-model="filter_maximum_apertures">
                            <label :for="'maximum_aperture' + item.id">{{item.name}}</label>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="focalLengths && show_focal_length == true">
                <div class="h5 mb-16" >Фокусное расстояние</div>
                <div class="mb-40">
                    <div class="brands-container">
                        <div class="mb-12 checkbox" v-for="(item, i) in focalLengths" :key="i">
                            <input :id="'focal_length' + item.id" type="checkbox" :value="item" v-model="filter_focal_lengths">
                            <label :for="'focal_length' + item.id">{{item.name}}</label>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="compatibilities && show_compatibility == true">
                <div class="h5 mb-16" >Совместимость</div>
                <div class="mb-40">
                    <div class="brands-container">
                        <div class="mb-12 checkbox" v-for="(item, i) in compatibilities" :key="i">
                            <input :id="'compatibility' + item.id" type="checkbox" :value="item" v-model="filter_compatibilities">
                            <label :for="'compatibility' + item.id">{{item.name}}</label>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="byTemperatures && show_by_temperature == true">
                <div class="h5 mb-16" >По температуре</div>
                <div class="mb-40">
                    <div class="brands-container">
                        <div class="mb-12 checkbox" v-for="(item, i) in byTemperatures" :key="i">
                            <input :id="'by_temperature' + item.id" type="checkbox" :value="item" v-model="filter_by_temperatures">
                            <label :for="'by_temperature' + item.id">{{item.name}}</label>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="lightTypes && show_light_type == true">
                <div class="h5 mb-16" >Тип света</div>
                <div class="mb-40">
                    <div class="brands-container">
                        <div class="mb-12 checkbox" v-for="(item, i) in lightTypes" :key="i">
                            <input :id="'light_type' + item.id" type="checkbox" :value="item" v-model="filter_light_types">
                            <label :for="'light_type' + item.id">{{item.name}}</label>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="LEDs && show_LED == true">
                <div class="h5 mb-16" >Светодиодный</div>
                <div class="mb-40">
                    <div class="brands-container">
                        <div class="mb-12 checkbox" v-for="(item, i) in LEDs" :key="i">
                            <input :id="'LED' + item.id" type="checkbox" :value="item" v-model="filter_LEDs">
                            <label :for="'LED' + item.id">{{item.name}}</label>
                        </div>
                    </div>
                </div>
            </div>




            <div v-if="max_price" class="mb-32">
                <div class="h5 mb-16" v-if="brands">Цена, руб.</div>
                <div class="price-container">
                    <input type="text" v-model="value_slider[0]" class="input-box" placeholder="Цена, от">
                    <input type="text" v-model="value_slider[1]" :max="max_price" class="input-box" placeholder="Цена, до">
                </div>
                <vue-slider v-model="value_slider" :lazy="true" :max="max_price"></vue-slider>
            </div>

            <button class="button btn-small btn-v2 w-100" @click="getProducts()">
                Показать товары
            </button>

            <div class="reset-button" @click="resetFilter()">
                <div class="h6">Сбросить фильтр</div>
            </div>
        </div>



    </div>

</template>


<script>
    import filter from "../../../services/filter";
    export default {
        data() {
            return {
                value_slider: [0, 1200],
                filter: filter,
                brand_search: null,
                filter_brands: [],
                filter_camera_types: [],
                filter_matrix_sizes: [],
                filter_lens_types: [],
                filter_bayonets: [],
                filter_maximum_apertures: [],
                filter_focal_lengths: [],
                filter_compatibilities: [],
                filter_by_temperatures: [],
                filter_light_types: [],
                filter_LEDs: [],
                show_camera_type: false,
                show_matrix_size: false,
                show_lens_type: false,
                show_bayonet: false,
                show_maximum_aperture: false,
                show_focal_length: false,
                show_compatibility: false,
                show_by_temperature: false,
                show_light_type: false,
                show_LED: false,
            }
        },

        computed: {
            brands() {
                return this.$store.getters.getBrands;
            },
            cameraTypes() {
                return this.$store.getters.getCameraTypes;
            },
            matrixSizes() {
                return this.$store.getters.getMatrixSizes;
            },
            lensTypes() {
                return this.$store.getters.getLensTypes;
            },
            bayonets() {
                return this.$store.getters.getBayonets;
            },
            maximumApertures() {
                return this.$store.getters.getMaximumApertures;
            },
            focalLengths() {
                return this.$store.getters.getFocalLengths;
            },
            compatibilities() {
                return this.$store.getters.getCompatibilities;
            },
            byTemperatures() {
                return this.$store.getters.getByTemperatures;
            },
            lightTypes() {
                return this.$store.getters.getLightTypes;
            },
            LEDs() {
                return this.$store.getters.getLEDs;
            },
            max_price() {
                return this.$store.getters.getMaxPrice;
            },
            filtered_brands() {
                let result = this.brands;

                if (this.brand_search) {
                    let search = this.brand_search;
                    search = search.toLowerCase();
                    result = this.brands.filter(item => {
                        let el = item.name.toLowerCase();
                        if (el.includes(search)) return item;
                    });
                }

                return result;
            }
        },

        watch: {
            $route() {
                this.resetFilter();
            },
            'cameraTypes'() {
                if (this.cameraTypes != null && Object.keys(this.cameraTypes).length > 0) this.show_camera_type = true;
                else this.show_camera_type = false;
            },
            'matrixSizes'() {
                if (this.matrixSizes != null && Object.keys(this.matrixSizes).length > 0) this.show_matrix_size = true;
                else this.show_matrix_size = false;
            },
            'lensTypes'() {
                if (this.lensTypes != null && Object.keys(this.lensTypes).length > 0) this.show_lens_type = true;
                else this.show_lens_type = false;
            },
            'bayonets'() {
                if (this.bayonets != null && Object.keys(this.bayonets).length > 0) this.show_bayonet = true;
                else this.show_bayonet = false;
            },
            'maximumApertures'() {
                if (this.maximumApertures != null && Object.keys(this.maximumApertures).length > 0) this.show_maximum_aperture = true;
                else this.show_maximum_aperture = false;
            },
            'focalLengths'() {
                if (this.focalLengths != null && Object.keys(this.focalLengths).length > 0) this.show_focal_length = true;
                else this.show_focal_length = false;
            },
            'compatibilities'() {
                if (this.compatibilities != null && Object.keys(this.compatibilities).length > 0) this.show_compatibility = true;
                else this.show_compatibility = false;
            },
            'byTemperatures'() {
                if (this.byTemperatures != null && Object.keys(this.byTemperatures).length > 0) this.show_by_temperature = true;
                else this.show_by_temperature = false;
            },
            'lightTypes'() {
                if (this.lightTypes != null && Object.keys(this.lightTypes).length > 0) this.show_light_type = true;
                else this.show_light_type = false;
            },
            'LEDs'() {
                if (this.LEDs != null && Object.keys(this.LEDs).length > 0) this.show_LED = true;
                else this.show_LED = false;
            },
            'filter.filter.price_from'() {
                if (!this.filter.filter.price_from) this.value_slider = [0, this.filter.filter.price_to];
            },
            'filter.filter.price_to'() {
                if (!this.filter.filter.price_to) this.value_slider = [this.filter.filter.price_from, this.max_price];
            },
            value_slider() {
                // this.filter.filter.price_from  = this.value_slider[0];
                // this.filter.filter.price_to  = this.value_slider[1];

                if (this.value_slider[0] > this.max_price) {
                    this.value_slider[0] = this.max_price - 1;
                    // this.filter.filter.price_from = this.max_price - 1;
                    this.value_slider[1] = this.max_price;
                    // this.filter.filter.price_to = this.max_price;
                }

                if (this.value_slider[1] > this.max_price) {
                    this.value_slider[1] = this.max_price;
                    // this.filter.filter.price_to = this.max_price;
                }
            }

        },

        methods: {
            getProducts() {
                this.filter.filter.price_from = this.value_slider[0];
                this.filter.filter.price_to = this.value_slider[1];
                if (this.filter_brands.length) this.filter.filter.brands = this.filter_brands;
                if (this.filter_camera_types.length) this.filter.filter.camera_types = this.filter_camera_types;
                if (this.filter_matrix_sizes.length) this.filter.filter.matrix_sizes = this.filter_matrix_sizes;
                if (this.filter_lens_types.length) this.filter.filter.lens_types = this.filter_lens_types;
                if (this.filter_bayonets.length) this.filter.filter.bayonets = this.filter_bayonets;
                if (this.filter_maximum_apertures.length) this.filter.filter.maximum_apertures = this.filter_maximum_apertures;
                if (this.filter_focal_lengths.length) this.filter.filter.focal_lengths = this.filter_focal_lengths;
                if (this.filter_compatibilities.length) this.filter.filter.compatibilities = this.filter_compatibilities;
                if (this.filter_by_temperatures.length) this.filter.filter.by_temperatures = this.filter_by_temperatures;
                if (this.filter_light_types.length) this.filter.filter.light_types = this.filter_light_types;
                if (this.filter_LEDs.length) this.filter.filter.LEDs = this.filter_LEDs;
                this.filter.filter.page = 1;
                if (this.$router.query) this.$router.replace({'query': null});
                this.filter.getProducts();
                document.getElementById('app').scrollIntoView({behavior: "auto"});

                if (window.innerWidth < 1200) this.$emit('close_filter', true);
            },

            resetFilter() {
                this.value_slider = [0, 1200];
                this.brand_search = null;
                this.filter_brands = [];
                this.filter_camera_types = [];
                this.filter_matrix_sizes = [];
                this.filter_lens_types = [];
                this.filter_bayonets = [];
                this.filter_maximum_apertures = [];
                this.filter_focal_lengths = [];
                this.filter_compatibilities = [];
                this.filter_by_temperatures = [];
                this.filter_light_types = [];
                this.filter_LEDs = [];
                //this.filter.resetFilter();
                //if (this.$route.path !== '/catalog') this.$router.push({path: '/catalog'});
                document.getElementById('app').scrollIntoView({behavior: "auto"})
            },

            closeFilter() {
                this.$emit('close_filter', true);
            }
        }
    }
</script>
